var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftwareAccessLicenses(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104.14 100",
    style: {
      enableBackground: "new 0 0 104.14 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--keysight-red);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.06,99.86H23.5c-3.66,0-6.63-2.97-6.63-6.63V6.49c0-3.66,2.97-6.63,6.63-6.63h46l18.19,18.78v74.6 C87.69,96.9,84.72,99.86,81.06,99.86L81.06,99.86z M23.5,2.73c-2.1,0-3.8,1.7-3.8,3.8v86.71c0,2.1,1.7,3.8,3.8,3.8h57.56 c2.1,0,3.8-1.7,3.8-3.8V19.79L68.3,2.7L23.5,2.73L23.5,2.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.39,20.38H72.52c-2.61,0-4.72-2.12-4.73-4.73V1.55h2.83v14.11c0,1.05,0.85,1.89,1.89,1.89h13.88V20.38 L86.39,20.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.57,18.14v-0.42c0-0.56,0-1.01,0-1.01h21.96c0,0,0,0.45,0,1.01v0.42H29.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.57,85.38v-0.42c0-0.56,0-1.01,0-1.01h21.96c0,0,0,0.45,0,1.01v0.42H29.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.57,36.37v-0.1c0-0.65,0-1.17,0-1.17h45.77c0,0,0,0.53,0,1.17v0.1H29.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.44,46.14v-0.19c0-0.62,0-1.13,0-1.13h39.32c0,0,0,0.5,0,1.13v0.19H29.44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.57,75.5v-0.1c0-0.65,0-1.17,0-1.17h45.77c0,0,0,0.53,0,1.17v0.1H29.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.57,65.7v-0.19c0-0.62,0-1.13,0-1.13h39.19c0,0,0,0.5,0,1.13v0.19H29.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.57,55.95v-0.13c0-0.64,0-1.16,0-1.16H71.3c0,0,0,0.52,0,1.16v0.13H29.57"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.5,70.6c0-2.13,1.73-3.85,3.85-3.85H99.9c2.13,0,3.85,1.72,3.85,3.85s-1.73,3.85-3.85,3.85H69.35 C67.23,74.45,65.5,72.72,65.5,70.6L65.5,70.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.78,48.7 37.83,70.6 75.78,92.47 75.78,48.7  "
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.49,37.38c0,2.13-1.73,3.85-3.85,3.85H4.09c-2.13,0-3.85-1.72-3.85-3.85c0-2.13,1.73-3.85,3.85-3.85 h30.55C36.77,33.53,38.49,35.25,38.49,37.38L38.49,37.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28.22,59.28 66.16,37.38 28.22,15.51 28.22,59.28  "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareAccessLicenses);
export default __webpack_public_path__ + "static/media/software-access-licenses.7957869302408492a07ee85f3e17e633.svg";
export { ForwardRef as ReactComponent };